import { createGlobalStyle, css } from "styled-components";
import { colors } from "./theme";
import bgLead from "../assets/img/imagem-apoio.png";

const GlobalStyle = createGlobalStyle`
  *,
  *::after,
  *::before {
    box-sizing: border-box;  
  }

  :root { 
    --toastify-color-warning: #F39035;
    
  .bg-modal-lead {
    background-image: url(${bgLead});
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    border-radius: 8px 0px 0px 8px;
  }

  .p-2-5 {
    padding: 2.5rem!important;
  }

  /* Deixar os modais sempre acima dos demais elementos da página */
  .modal, .modal-backdrop {
    z-index: 9999;
  }

  .modal-lead {
    .modal-lg {
        max-height: 40vh;
    }
  }

  @media (min-width: 992px) {
    .modal-lg {
        max-width: 900px;
    }
  }

  #sendMail {
    cursor: pointer !important;
  }

  .btn:focus {
    box-shadow: none;
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .langChange:hover{
    cursor: pointer;
  }

  .emoji-content {
    width: 40px; 
    height: 30px;
    margin-right: 15px;
  }

  .emoji {
    width: 100%;
    height: 100%;
    transition: all .5s;
  }

  .emoji-content:hover .emoji{
    transform: scale(1.2);
  }

  .font-light {
    font-weight: 300;
  }

  .font-400 {
    font-weight: 400;
  }

  .font-500 {
    font-weight: 500;
  }

  .text-bold {
    font-weight: bolder;
  }

  .font-12 {
    font-size: 12px;
  }

  .font-13 {
    font-size: 13px;
  }

  .font-14 {
    font-size: 14px;
  }

  .font-16 {
    font-size: 16px;
  }

  .font-18 {
    font-size: 18px;
  }

  .font-20 {
    font-size: 20px;
  }

  .font-22 {
    font-size: 22px;
  }

  .font-24 {
    font-size: 24px;
  }

  .mb-2rem {
    margin-bottom: 2rem !important;
  }

  .mr-2{
    margin-right: 8px;
  }

  .vh-50 {
    height: 50vh !important;
  }

  .input-group > .form-control {
      /* border-left: 0px !important; */
      border: 1px solid #EEEEEE !important;
      /* border-right: 0px !important; */
  }

  .input-group-text {
    /* padding: 0.375rem 0rem 0.375rem 0.75rem !important; */
    border: 1px solid #EEEEEE !important;
    border-left: 0px;
    background-color: ${colors.greyscale.white};
    color: ${colors.greyscale.grey};
  }

  .eye-password-icon {
    cursor: pointer;
    margin-top: 12px !important;
    width: 100%;
    height: 0px;
    position: absolute;
    text-align: end;
    padding-right: 15px;
    z-index: 99;
  }

  .eye-password-icon-login {
    cursor: pointer;
    margin-top: -37px !important;
    width: 100%;
    height: 0px;
    position: absolute;
    text-align: end;
    padding-right: 15px;
    z-index: 99;
  }

  .eye-password-icon-modal {
    cursor: pointer;
    margin-top: -32px !important;
    width: 83%;
    height: 0px;
    position: absolute;
    text-align: end;
    z-index: 99;

    @media (max-width: 520px) {
      width: 75%;
    }
  }

  .eye-password-manger-user {
    cursor: pointer;
    margin-top: -32px !important;
    width: calc(100% - 85px);
    height: 0px;
    position: absolute;
    text-align: end;
    z-index: 9;

    // @media (max-width: 540px) {
    //   width: 75%;
    // }

    // @media (min-width: 550px) and (max-width: 768px){
    //   width: 47%;
    // }

    // @media (min-width: 769px) and (max-width: 992px){
    //   width: 49%;
    // }

    // @media (min-width: 993px) and (max-width: 1366px){
    //   width: calc(100% - 85px);
    // }
  }

  .wpp-icon {
    margin-top: 3px !important;
    margin-left: 5px !important;
    margin-right: 5px !important;
    width: 100%;
    height: 0px;
    position: absolute;
    text-align: end;
    padding-right: 50px;
    z-index: 99;
  }

  .wpp-switch {
    position: absolute;
    text-align: end;
    width: 100%;
    height: 0px;
    padding-top: 4px;
    padding-right: 7px;
    z-index: 99;
  }

  .icon-integration {
    background: #F1FBF8 !important;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    border-radius: 4px;
    height: 50px;
    width: 50px;
    left: 15px;
    top: 115px;
  }

  .bg-body-card-integration {
    background: ${colors.greyscale.white} !important;
    border-top: 0px solid ${colors.greyscale.grey2};
    border-right: 2px solid ${colors.greyscale.grey2};
    border-left: 2px solid ${colors.greyscale.grey2};
    border-bottom: 2px solid ${colors.greyscale.grey2};
    margin-right: -1px;
    margin-left: -1px;
    margin-bottom: -1px;
    border-radius: 0px 0px 10px 10px;
  }

  .bg-card-integration {
    background: ${colors.mainColors.blueberry} !important;
    border: 1px solid transparent !important;
    height: 100%;
    border-radius: 10px;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }

  .bg-light {
    background: ${colors.greyscale.light_grey} !important;
  }

  .bg-config {
    background: #F1FBF8 !important;
    min-height: 83vh;
  }

  .bg-gokursos {
    background: #FF3452 !important;
  }

  .bg-unities {
    background: ${colors.mainColors.verde_dstore} !important;
  }

  .bg-courses {
    background: ${colors.mainColors.indigo} !important;
  }

  .bg-disciplines {
    background: ${colors.mainColors.blueberry} !important;
  }

  .bg-themes {
    background: ${colors.mainColors.roxo_delinea} !important;
  }

  .bg-objects {
    background: ${colors.mainColors.capri} !important;
  }

  .menuActive{
    color: ${colors.greyscale.white} !important;

    svg {
      color: ${colors.greyscale.white} !important;
    }
  }
  
  .hoverMenu {
    cursor: pointer;
    height: 48px;
    border-radius: 5px;
    font-family: 'Lato';
    color: ${colors.greyscale.darker_grey};
    
   
  }

  .hoverMenu:hover {
    background: #F0F2FF;
  }

  .hoverMenuPlans {
    cursor: pointer;
    height: 6vh;
    border-radius: 5px;
    font-family: 'Lato';
    color: ${colors.greyscale.white};
    background: ${colors.mainColors.orange};
    
    @media (max-height: 768px) {
      height: 8vh;
    }

    @media (min-height: 800px) and (max-width: 900px) {
      height: 5vh;
    }
  }

  .hoverMenuPlans:hover {
    background: ${colors.mainColors.dark_orange};
  }

  .menuActiveManager {
    background: ${colors.mainColors.verde_dstore};
    font-weight: bolder;
  }

  .subMenuActiveManager {
    background: ${colors.mainColors.verde_dstore};
    font-weight: bolder;
    border-radius: 0px;

    &:hover {
      background: ${colors.mainColors.verde_dstore} !important;
    }
  }
  
  .hoverMenuManager {
    cursor: pointer;
    height: 5vh;
    font-family: 'Lato';
    color: ${colors.greyscale.white};
    border-radius: 5px;
    width: 100%;
    
    @media (max-height: 768px) {
      height: 6vh;
    }

    @media (min-height: 800px) and (max-width: 900px) {
      height: 6vh;
    }
  }

  .hoverMenuManager:hover {
    background: ${colors.greyscale.semiblack};
  }
 
  .div-hover-menu-manager {
    position: absolute;
    background: ${colors.greyscale.black};
    border-radius: 0px 5px 5px 0px;
    width: 195px;
    left: 66px;
    padding: 4px 8px;
  }

  .divider-menu-manager {
    @media (max-width: 900px) {
      border: 1px solid white;
      border-radius: 2px;
      margin-left: 15px;
      width: 93%;
    }
  }

  .collapsing {
    transition: height 0.5s ease !important;
  }

  .dropdownCustom {
    min-width: 13rem;
    position: absolute;
    right: 20px;
    top: 60px;
    border-radius: 5px;
    border: 1px solid ${colors.greyscale.black};
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);
    background: ${colors.greyscale.black};

    @media (max-width: 750px) {
      right: 0px;
      width: 100%;
      box-shadow: none;
      top: 65px;

      .icon-user-options {
        justify-content: end;
      }
    }
    
    .dropdown-item {
      padding: 12px 15px;
    }

    .dropdown-item.active, .dropdown-item:active, .dropdown-item:hover, .dropdown-item:focus {
      text-decoration: none;
      background-color: ${colors.greyscale.semiblack} !important;
    }
    
    .icon-user-options {
      color: ${colors.greyscale.white};
      font-size: 25px;
      display: flex;
      align-items: center;
    }
  }

  .active-user {
    cursor: pointer;
    height: 48px;
    border-radius: 5px;
    font-family: 'Lato';
    color: ${colors.mainColors.blueberry};
    background-color: #F0F2FF;
    width: 100%;

 
  }

  .menu-icon { 
    color: ${({ theme }) => theme.menuItems};
    font-size: 27px;
  }

  .menu-item-user {
    margin: 8px 0;

    img, .sb-avatar__text {
      display: inline-block;
      vertical-align: middle;
    }
  }

  .menu-partner-items-wrapper {
    margin-top: auto;
  }

  .menu-visitor-items-wrapper {
    margin-top: auto;
  }

  .menu-item-notifications {

  }

  .wrapper-login {
    position: relative;
    width: 375px;
    margin-left: auto;
    margin-right: auto;
    max-height: 100%;
    display: flex;
    flex-direction: column;
    font-family: 'Lato';
  }

  .button-bottom {
    position: absolute;
    bottom: 0;
  }

  .text-grey {
    color: ${colors.greyscale.grey};
  }

  .text-light-grey {
    color: ${colors.greyscale.light_grey};
  }

  .text-dstore {
    color: ${colors.mainColors.verde_dstore};
  }

  .text-success {
    color: ${colors.alertColors.green_crayola} !important;
  }
  .bg-success {
    background: ${colors.alertColors.green_crayola} !important;
  }
  
  .text-danger {
    color: ${colors.alertColors.carmine_pink} !important;
  }
  .bg-danger {
    background: ${colors.alertColors.carmine_pink} !important;
  }

  .text-info {
    color: ${colors.mainColors.blueberry} !important;
  }
  .bg-info {
    background: ${colors.mainColors.blueberry} !important;
  }

  .text-warning {
    color: ${colors.alertColors.spanish_yellow} !important;
  }
  .bg-warning {
    background: ${colors.alertColors.spanish_yellow} !important;
  }

  #popover-password-validation {
    min-width: 300px !important;
    box-shadow: 0px 2px 8px rgba(51, 51, 51, 0.15);
    border-radius: 4px;
    border: 0px;

    .popover-arrow::before {
      border-bottom-color: rgb(0 0 0 / 10%);
    }
  }

  .ds-input-group{
    width: 100%;
    height: 40px;

    .input-group-text {
      border: 1px solid ${colors.mainColors.very_light_green};
      border-right: 0px;
      color:  ${colors.mainColors.blueberry};
    }

    .input-text {   
      color:  ${colors.greyscale.black};
      background-color: ${colors.greyscale.white};
      font-size: 14px;
      line-height: 18px;
      border: 1px solid ${colors.mainColors.very_light_green};
      border-radius: 4px;
    }
  }

  .ds-select {
    color:  ${colors.greyscale.darker_grey};
    background-color: ${colors.greyscale.white};
    font-size: 14px;
    line-height: 18px;
    height: 40px;
    border: 1px solid #EEEEEE;
    border-radius: 4px;

    option{
      color:  #747474;
    }
  }

  .select-form {
    background-color: ${colors.greyscale.white};
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    height: 40px;
    border-radius: 4px;
    display: flex;
    
    .p-dropdown-label, .p-dropdown-trigger {
      color: ${colors.mainColors.blueberry} !important;
    }
  }

  .select-form-default {
    background-color: ${colors.greyscale.white};
    font-size: 14px;
    line-height: 14px;
    height: 40px;
    border-radius: 4px;
    display: flex;
  }

  .pl-0 {
    padding-left:0;
  }

  .pr-0 {
    padding-right:0;
  }

  .p-multiselect-panel .p-multiselect-header .p-multiselect-filter-container .p-inputtext {
    height: 35px !important;
  }

  .p-multiselect-panel .p-multiselect-items .p-multiselect-item {
    color: #747474 !important;
  }

  .p-multiselect .p-multiselect-trigger {
    /* color: ${colors.greyscale.light_grey}; */
  }

  .p-multiselect .p-multiselect-label.p-placeholder {
    color: #747474;
  }

  .Toastify__toast-theme--colored.Toastify__toast--success {
    background: ${colors.mainColors.light_verde_dstore};
  }

  .photo-edit-group {
    input[type="file"] {
      display: none;
    }

    label {
      font-size: 30px;
      position: absolute;
      top: 50%;
      left: 10%;
      cursor: pointer;
      z-index: 9;
    }

    .sb-avatar__text, .sb-avatar__image {
      opacity: 0.3;
    }
  }

  .photo-edit-group-manager {
    input[type="file"] {
      display: none;
    }

    .label-remove {
      left: 17%;

      @media (max-width: 375px) {
        left: 35%;
      }

      @media (min-width: 376px) and (max-width: 414px) {
        left: 32%;
      }

      @media (min-width: 415px) and (max-width: 820px) {
        left: 38%;
      }

      @media (min-width: 821px) and (max-width: 1366px) {
        left: 24.5%;
      }

    }

    label {
      margin-top: 5vh;
      font-size: 30px;
      position: absolute;
      left: 14%;
      cursor: pointer;
      z-index: 9;
      
      @media (max-width: 375px) {
        margin-top: 7vh;
        left: 20%;
      }

      @media (min-width: 376px) and (max-width: 414px) {
        margin-top: 5.5vh;
        left: 16%;
      }

      @media (min-width: 415px) and (max-width: 820px) {
        margin-top: 4.3vh;
        left: 31%;
      }

      @media (min-width: 821px) and (max-width: 1366px) {
        margin-top: 6.5vh;
        left: 19%;
      }
    }

    .sb-avatar__text, .sb-avatar__image {
      opacity: 0.3;
    }
  }

  .photo-name-template {
    .sb-avatar__image {
      max-width: 30px !important;
    }
  }

  .card-support-contact {
    box-shadow: 0px 1.79551px 7.18204px rgba(178, 178, 178, 0.2);
    border: 0px;
  }

  ${() => css`
    ::placeholder {
      color: ${({ theme }) => theme.placeholder} !important;
    }

    ::-webkit-scrollbar {
      width: 9px;
      height: 9px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: ${colors.greyscale.light_grey};
      border-radius: 10px;
    }
    
    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: ${colors.greyscale.dark_grey}; 
      border-radius: 10px;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: ${colors.greyscale.darker_grey}; 
    }

    body {
      background: ${({ theme }) => theme.body};
      color: ${({ theme }) => theme.text};
      margin: 0;
      padding: 0;
      font-family: 'Lato', sans-serif;    
      transition: all 0.25s linear;
    }

    a {
      color: ${({ theme }) => theme.linkColor};
      text-decoration: none;
    }

    a:hover {
      color: ${({ theme }) => theme.linkColorHover};
    }

    .link-blueberry {
      color: ${colors.mainColors.blueberry};
      text-decoration: none;
    }

    .link-blueberry:hover {
      color: ${colors.mainColors.hover_blueberry};
    }

    .mr-1 {
      margin-right: 5px;
    }

    .ml-1 {
      margin-left: 5px;
    }

    .mr-2 {
      margin-right: 10px;
    }

    .ml-2 {
      margin-left: 10px;
    }

    .mr-3 {
      margin-right: 15px;
    }

    .ml-3 {
      margin-left: 15px;
    }

    .ml-4 {
      margin-left: 25px;
    }

    .mr-4 {
      margin-right: 25px;
    }

    .ml-5 {
      margin-left: 5%;
    }

    .mr-5 {
      margin-right: 5%;
    }

    .account-sign-title {
      color: ${({ theme }) => theme.menuItems};
      font-size: 12px;
      margin-left: 20px;

      svg {
        color: ${({ theme }) => theme.linkColor};
        width: 20px;
        height: 21px;
      }
    }

    .account-card {
      box-shadow: 4px 4px 8px rgba(55, 200, 150, 0.4);
      border-radius: 16px;
      border: 0px;
    }

    .badge-mail-pending {
      font-size: 12px; 
      margin-left: 20px; 
      background: ${colors.alertColors.beach_sand} !important;
      color: #33333370 !important;
    }

    .title-materials {
      color: ${({ theme }) => theme.titleMaterials};
      font-weight: 700;
      font-size: 24px;
    }

    #tabs-materials {
      .nav-tabs .nav-link {
        border: 0;
      }

      .nav-link {
        color: ${({ theme }) => theme.menuItems};
      }

      .nav-item > .active {
        color: ${({ theme }) => theme.titleMaterials};
        border-bottom: 3px solid ${({ theme }) => theme.titleMaterials};
        background-color: transparent;
        font-weight: 600;
      }
    }

    .modal-content {
      border: 0px;
      border-radius: 0.6rem;
    }

    .modal-body {
      padding: 1.5rem 2.3rem;
    }

    .modal-footer {
      justify-content: space-between;
      padding: 1rem 2.2rem;
    }

    .modal-title {
      font-size: 18px;
    }

    .p-datepicker {
      z-index: 9999 !important;

      @media (min-width: 768px) and (max-width: 1367px) {
        margin-top: 30px !important;
      }

      .p-datepicker-calendar {
        width: 75%;
      }

      table td {
        padding: 0;
      }
    }

    .doc-div {
      border: 1px solid rgb(207, 207, 207);
      min-height: 100px;
      margin-left: 12px;
      width: 97%;
      border-radius: 5px;
    }

    .doc-attached {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      color: ${colors.mainColors.blueberry}
    }

    .close-button-doc-attached {
      width: 0.6em;
      height: 0.6em;
      border-radius: 1.25rem;
      margin-right: 5px;

      &:focus {
        box-shadow: none
      }
    }

    .modal-file {
      .btn-close {
        filter: none !important;
      }
    }

    .p-inputnumber-input {
      width: 100%;
    }

    .modal-form-variant {
      .modal-header {
        padding: 1rem 2.3rem;
        border-top-left-radius: 0.6rem;
        border-top-right-radius: 0.6rem;
        background: ${colors.mainColors.blueberry} !important;
        color: ${colors.greyscale.white};

        .btn-close {
          filter: brightness(0) invert(1);
        }
      }

      .file-view-header {
        background: ${colors.greyscale.white} !important;
        color: ${colors.greyscale.darker_grey};
      }

      .btn-primary, .btn-primary:disabled {
        color: ${colors.greyscale.white};
        background-color: ${colors.mainColors.blueberry};
        border-color: ${colors.mainColors.blueberry};
      }

      .btn-primary:hover {
        background-color: ${colors.mainColors.hover_blueberry};
        border-color: ${colors.mainColors.hover_blueberry};
      }
      

      .btn-outline-primary,.btn-outline-primary:disabled {
        color: ${colors.mainColors.blueberry};
        border-color: ${colors.mainColors.blueberry};
      }

      .btn-outline-primary:hover {
        color: ${colors.greyscale.white};
        background-color: ${colors.mainColors.hover_blueberry};
        border-color: ${colors.mainColors.hover_blueberry};
      }
    }

    .modal-default-variant {
      .modal-header {
        padding: 1rem 2.3rem;
        border-top-left-radius: 0.6rem;
        border-top-right-radius: 0.6rem;
        color: ${colors.greyscale.black};
        }
      }

    .modal-confirm-variant {
      .modal-header {
        padding: 1rem 2.3rem;
        border-top-left-radius: 0.6rem;
        border-top-right-radius: 0.6rem;
        background: ${colors.mainColors.crab_coral} !important;
        color: ${colors.greyscale.white};

        .btn-close {
          filter: brightness(0) invert(1);
        }
      }

      .btn-primary, .btn-primary:disabled {
        color: ${colors.greyscale.white};
        background-color: ${colors.mainColors.crab_coral};
        border-color: ${colors.mainColors.crab_coral};
      }

      .btn-primary:hover {
        background-color: ${colors.alertColors.tart_orange};
        border-color: ${colors.alertColors.tart_orange};
      }

      .btn-outline-primary,.btn-outline-primary:disabled {
        color: ${colors.mainColors.crab_coral};
        border-color: ${colors.mainColors.crab_coral};
      }

      .btn-outline-primary:hover {
        color: ${colors.greyscale.white};
        background-color: ${colors.alertColors.tart_orange};
        border-color: ${colors.alertColors.tart_orange};
      }
    }

    .modal-confirm-default-variant {
      .modal-header {
        padding: 1rem 2.3rem;
        border-top-left-radius: 0.6rem;
        border-top-right-radius: 0.6rem;
        color: ${colors.greyscale.black};
      }

      .btn-primary, .btn-primary:disabled {
        color: ${colors.greyscale.white};
        background-color: ${colors.mainColors.verde_dstore};
        border-color: ${colors.mainColors.verde_dstore};
      }

      .btn-primary:hover {
        background-color: ${colors.mainColors.dark_verde_dstore};
        border-color: ${colors.mainColors.dark_verde_dstore};
      }

      .btn-danger, .btn-danger:disabled {
        color: ${colors.greyscale.white};
        background-color: ${colors.alertColors.danger_red};
        border-color: ${colors.alertColors.danger_red};
      }

      .btn-danger:hover{
        background-color: ${colors.alertColors.danger_red};
        border-color: ${colors.alertColors.danger_red};
      }

      .btn-outline-primary,.btn-outline-primary:disabled {
        color: ${colors.mainColors.verde_dstore};
        border-color: ${colors.mainColors.verde_dstore};
      }

      .btn-outline-primary:hover {
        color: ${colors.greyscale.white};
        background-color: ${colors.mainColors.dark_verde_dstore};
        border-color: ${colors.mainColors.dark_verde_dstore};
      }
    }

    .text-primary {
      color: ${({ theme }) => theme.btnPrimary} !important;
    }

    .btn-plans {
      color: ${colors.greyscale.white};
      background-color: ${colors.mainColors.orange};
      
      &:hover {
        color: ${colors.greyscale.white};
        background-color: ${colors.mainColors.dark_orange};
      }
    }

    .btn-primary, .btn-primary:disabled {
      color: ${colors.greyscale.white};
      background-color: ${({ theme }) => theme.btnPrimary};
      border-color: ${({ theme }) => theme.btnPrimary};
    }

    .btn-primary:hover {
      background-color: ${({ theme }) => theme.btnPrimaryHover}; 
      border-color: ${({ theme }) => theme.btnPrimaryHover};
    }

    .btn-danger, .btn-danger:disabled {
      color: ${colors.greyscale.white};
      background-color: ${colors.alertColors.danger_red};
      border-color: ${colors.alertColors.danger_red};
    }

    .btn-danger:hover{
      background-color: ${colors.alertColors.danger_red};
      border-color: ${colors.alertColors.danger_red};
    }

    .btn-outline-primary,.btn-outline-primary:disabled {
      color: ${({ theme }) => theme.btnPrimary};
      border-color: ${({ theme }) => theme.btnPrimary};
    }

    .btn-outline-primary:hover {
      color: ${colors.greyscale.white};
      background-color: ${({ theme }) => theme.btnPrimaryHover};
      border-color: ${({ theme }) => theme.btnPrimaryHover};
    }

    .input-group:focus-within {
      .input-group-text, .form-control{
        border-color: ${({ theme }) => theme.inputBorderFocus} !important;
      }
    }

    .form-control:focus, .form-select:focus {
        border-color: ${({ theme }) => theme.inputBorderFocus} !important;
        box-shadow: none !important;
    }

    .form-check-input {
      cursor: pointer;
    }

    .form-check-input:focus {
      border-color: ${({ theme }) => theme.inputBorderFocus} !important;
      box-shadow: none !important;
    }

    .row-card-login {
      background: ${colors.mainColors.verde_dstore};
    }

    @media(max-width: 878px) {
      .card-login {
        border-radius: 0px !important;
      }
    }

    @media(max-width: 878px){
      .card-login {
        border-radius: 0px !important;
      }

      .row-illustration-login {
        display: none !important;
      }
    }

    .card-login {
      border-radius: 24px 0px 0px 24px;
      background: ${({ theme }) => theme.body};
      align-items: center;
      display: flex;
    }

    .form-switch > .form-check-input {
      height: 20px;
    }

    .form-switch > .form-check-input:checked {
      background-color: ${colors.mainColors.verde_dstore};
      border-color: ${colors.mainColors.verde_dstore};
    }

    .errorFeedback {
      font-size: 14px;
      color: ${colors.alertColors.tart_orange};
      font-weight: 600;
      margin-top: 4px;
    }

    .ReactInputVerificationCode__item.is-active {
      box-shadow: none;
      border: 1px solid ${({ theme }) => theme.inputBorderFocus};
    }

    // Verify Code styles
    .vi__wrapper {
      width: 90% !important;

      @media (max-width:600px) {
        width: 100% !important;
      }
    }

    .container-code {
      height: 40px;
      text-transform: uppercase;

      @media (max-width:600px) {
        height: 50px;
      }
    }

    .character {
      line-height: 37px;
      font-size: 20px;
      color: ${colors.greyscale.black};
      border: 1px solid #e1e1e1;
      border-radius: 8px;
      margin-left: 8px;
    }

    .character:first-child {
      margin-left: 0;
    }

    .character--inactive {
      background-color: #F6F7FB;
    }

    .character--selected {
      border: 1px solid ${({ theme }) => theme.inputBorderFocus};
    }

    .resend-code, .sync-material {
      font-size: 20px;
      -webkit-animation:spin 4s linear infinite;
      -moz-animation:spin 4s linear infinite;
      animation:spin 4s linear infinite;
    }

    @-moz-keyframes spin { 100% { -moz-transform: rotate(-360deg); } }
    @-webkit-keyframes spin { 100% { -webkit-transform: rotate(-360deg); } }
    @keyframes spin { 100% { -webkit-transform: rotate(-360deg); transform:rotate(-360deg); } }

    // Verify Code styles

    .text-black { 
      color: ${({ theme }) => theme.titles} !important;
    }

    .text-dark-grey { 
      color: ${({ theme }) => theme.subTitles};
    }

    .text-darker-grey { 
      color: ${({ theme }) => theme.markText};
    }

    .text-blueberry { 
      color: ${({ theme }) => theme.titleMaterials};
    }

    .text-green-dstore { 
      color: ${colors.mainColors.verde_dstore};
    }
    
    .loading-container {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 99%;
    }

    .spinner-border {
      width: 3rem;
      height: 3rem;
      border: 0.35em solid currentColor;
      border-right-color: transparent;
    }

    .icon-withdrawal {
      cursor: pointer;
      font-size: 24px;
    }

    .icon-disabled {
      cursor: auto;
      font-size: 24px;
      color: ${colors.greyscale.dark_grey}
    }

    .input-currency {
      .p-inputtext {
        font-size: 2rem !important;
        font-family: 'Lato';
        font-weight: 600;
        width: 100%;
      }
    }

    .card-account {
      background: linear-gradient(to right, ${
			colors.mainColors.verde_dstore
		} 50%, transparent 0);
      background-size: 200% 100%;
      background-position: right;
      animation: makeItfadeIn .5s 0s forwards;      
      color: ${colors.greyscale.white};
    }

    @keyframes makeItfadeIn {
      100% {
        background-position: left;
      }
    }

    .select-period-input {
      .p-inputtext {
        border: 1px solid ${colors.mainColors.blueberry};
        border-right: 0px;
      }
      
      .p-inputtext, .p-button-icon-only {
        height: 35px;
        color: ${colors.mainColors.blueberry};
        background: ${colors.greyscale.white};        
      }
    }

    .p-datatable {
      font-family: 'Lato', sans-serif;
    }

    .p-datatable-emptymessage > td {
      text-align: center !important;
    }

    .p-dropdown-panel {
      z-index: 9999 !important;
    }
    .p-dropdown-items-wrapper {
      max-height: 360px !important;
    }

    .p-menu.wider-menu {
      width: 216px;
    }

    .p-disabled, .p-component:disabled {
      opacity: 0.6;
      background: lightgrey;
    }

    .item-menu-configs {
      cursor: pointer;
      border-radius: 4px;
      color: ${colors.greyscale.darker_grey};

      &:hover {
        background: ${colors.mainColors.white_lilac};
      }
    }

    .item-menu-configs-selected {
      cursor: pointer;
      border-radius: 4px;
      background: ${colors.mainColors.verde_dstore};
      color: ${colors.greyscale.white};

      &:hover {
        background: ${colors.mainColors.dark_verde_dstore};
      }
    }

    .add-planilhas {
      .accordion-item {
        border: 0px;
      }

      .accordion-body {
        border: 1px dashed ${colors.greyscale.grey2};
        padding: 0.3rem 1rem;
        margin-top: 7px;
      }

      .accordion-header {
        .accordion-button {
          padding: 0.5rem 1.25rem;
        }

        .accordion-button::after {
          filter: brightness(0.5);
        }

        .accordion-button:not(.collapsed) {
          background: #F6F7FB;
          color: ${colors.greyscale.darker_grey};
          box-shadow: none;
        }

        .accordion-button:focus {
          border-color: white;
        }
      }
    }

    .link-green {
      color: ${colors.mainColors.verde_dstore};
      
      &:hover {
        color: ${colors.mainColors.dark_verde_dstore};
      }
    }

    .sidebar-import-header {
      position: absolute;
      top: 20px;      
    }

    .sidebar-import-content {
      height: calc(100% - 90px);
      overflow: auto;

      ::-webkit-scrollbar {
        width: 7px;
        height: 7px;
      }

      /* Track */
      ::-webkit-scrollbar-track {
        background: ${colors.greyscale.light_grey};
        border-radius: 10px;
      }
      
      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: ${colors.greyscale.grey}; 
        border-radius: 10px;
        
        &:hover {
          background: ${colors.greyscale.darker_grey}; 
        }
      }
    }

    .sidebar-import-footer {
      position: absolute;
      bottom: 20px;
      border-top: 1px solid ${colors.greyscale.light_grey};
      width: 95%;
    }

    .back-auth-div {
      top: 1.5rem;
      left: 1.5rem;
      position: absolute;
      display: flex;
      color: ${colors.greyscale.white};
      transition: all: 0.4s;
      width: 70%;

      @media (max-width: 879px) {
        color: ${colors.greyscale.black};
      }

      @media (max-width: 375px) {
        left: 0;
      }

      .back-auth-button {
        cursor: pointer;
        
        &:hover {
          color: ${colors.greyscale.light_grey}
        }
      }
    }

    .form-auth {
      .form-control {
        ::placeholder {
          color: ${colors.greyscale.grey2} !important;
          opacity: 1;
        }

        padding: 12px 16px;
        border: 1px solid ${colors.greyscale.grey2};
      }

      .form-label {
        font-size: .875rem;
      }

      .gap-5 {
        gap: 2rem !important;
      }

      button {
        height: 48px !important;
      }
    }

    .div-item-navbar {
      border-radius: 6px;
      padding: 8px 16px;
      cursor: pointer;

      &:not(.p-disabled).selected {
        color: #157A57 !important; 
        background: #F1FBF8;
      }

      &:not(.p-disabled).selected-item {
        color: #fff !important; 
        background: ${colors.mainColors.verde_dstore} !important;
      }

      &:hover {
        color: #157A57 !important; 
        background: #F1FBF8;
      }
    }

    .item-dropdown-manager-bar {
      border: none; 

      &:not(.p-disabled).selected {
        color: #157A57 !important; 
        background: #F1FBF8;
      }

      &:not(.p-disabled).p-focus {
        outline: 0 none;
        outline-offset: 0;
        box-shadow: none;
        border-color: none;
        background: #F1FBF8;

        .p-dropdown-label, .p-multiselect-label {
          color: #157A57 !important; 
        }
      }
      .p-dropdown-label, .p-multiselect-label {
        color: ${colors.greyscale.black} !important; 
      }
      
      &:hover {
        .p-dropdown-label, .p-multiselect-label {
          color: #157A57 !important; 
        }

        background: #F1FBF8;
      }

      .p-dropdown-trigger, .p-multiselect-trigger {
        justify-content: start;
        width: 1.5rem;
        color: ${colors.greyscale.black};
      }

    }

    .item-panel-dropdown-manager-bar {
      .p-multiselect-items-wrapper {
        max-height: 300px !important;
      }
    }

    .p-checkbox .p-checkbox-box.p-highlight {
      border-color: ${colors.mainColors.verde_dstore} !important;
      background: ${colors.mainColors.verde_dstore} !important;
    }

    .list-indicators {
      padding-left: 1rem;
      text-align: start;
      margin-bottom: 5px;
    }

    .tooltip-inner {
      max-width: 650px;
    }

    .logo-form {
      @media (max-width: 520px) {
        margin-top: 50px;
      }
    }

    .d-none-lg-table {
      @media (min-width: 992px) and (max-width: 1199px) {
        display: none !important;
      }
    }
    
    .d-none-md-table {
      @media (min-width: 947px) and (max-width: 991px) {
        display: none !important;
      }
    }

    .d-none-xs-table {
      @media (max-width: 946px) {
        display: none !important;
      }
    }

    .d-none-xxs-table {
      @media (max-width: 575px) {
        display: none !important;
      }
    }

    .hide-photo {
      @media (max-width: 1299px) {
        display: none !important;
      }
    }

    .span-ellipsis {
      white-space: nowrap;
      text-overflow: ellipsis;
      display: block;
      overflow: hidden;
    }

    .p-picklist-list-wrapper {
      @media (max-width: 899px) {
          width: 100% !important;
      }

      @media (min-width: 900px) {
          width: 50vh !important;
      }
    }

    .p-sidebar-mask-scrollblocker {
      z-index: 9999 !important;
    }

    .empty-message-opt-group {
      background: white;
      padding: 0.75rem 1.25rem;
      margin-left: -20px;
      margin-right: -20px;
      margin-bottom: -12px;
      font-weight: 400;
    }
    
    .Toastify__toast-container {
      z-index: 99999 !important;
    }

    .dropdown-table-view {
   

      .p-dropdown-label {
        padding: 8px 16px;
        color: ${colors.mainColors.blueberry};
      }

      .p-dropdown-trigger {
        width: 2rem;
        color: ${colors.mainColors.blueberry};
      }
    }

    .card-options-publish {
      background: #F6F7FB;
      border: 0px;
      box-shadow: 1px 2px 4px rgba(51, 51, 51, 0.25);
      border-radius: 4px;
      font-size: 16px;
      text-align: center;
    }
      
    .card-body {
      padding: 1.8rem 1.8rem;
    };

    .p-multiselect-panel {
      z-index: 9999 !important;
    }

    .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider { 
      background: #37C896;

    }

    .p-inputswitch.p-inputswitch-checked:not(.p-disabled):hover .p-inputswitch-slider {
      background: #37C896;
    }

    .input-material-price {
      height: 40px;
    }

    .indicator-position {
      position: absolute;
      left: -13px;

      @media (min-width: 1500px) {
        left: 0px;
      }
    }

    .indicator-position-publication {
      position: absolute;
      left: 10px;
      
      @media (min-width: 1500px) {
        left: 30px;
      }
    }

    .div-plans {
      padding: 20px 20px 0px 20px;

      @media (min-width:720px) {
        padding: 30px 80px 0px 80px;
      }
    }

    .div-select-plan {
      text-align: -webkit-center;
      overflow-y: auto;
      max-height: 63vh;
      width: 100%;

      ::-webkit-scrollbar {
        width: 7px;
        height: 7px;
      }

      /* Track */
      ::-webkit-scrollbar-track {
        background: ${colors.greyscale.light_grey};
        border-radius: 10px;
      }
      
      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: ${colors.greyscale.grey}; 
        border-radius: 10px;
        
        &:hover {
          background: ${colors.greyscale.darker_grey}; 
        }
      }
    }

    .card-location-plans {
      border: 1px solid #DDDDDD;
      box-shadow: 1px 2px 4px rgba(51, 51, 51, 0.25);
      border-radius: 8px;
      width: calc(100% - 20px) !important;
      display: flex;
      cursor: pointer;

      &:hover {
        background: #f9f8f8;
      }

      .p-radiobutton .p-radiobutton-box:not(.p-disabled):not(.p-highlight):hover {
        border-color: #ace9ca;
      }
    }

    .card-plan-selected {
      border: 1px solid #37C896 !important;

      .p-radiobutton .p-radiobutton-box.p-highlight {
        border-color: ${colors.mainColors.verde_dstore} !important;
        background: #ffffff !important;
      }

      .p-radiobutton .p-radiobutton-box .p-radiobutton-icon {
        background-color: ${colors.mainColors.verde_dstore} !important;
      }
    }

    .accordion-phase {
      .accordion-button {
        padding: 2px 10px !important;
      }

      .accordion-button:not(.collapsed) {
        color: ${colors.greyscale.darker_grey};
        background-color: ${colors.greyscale.white};
      }

      .accordion-button::after {
        position: absolute;
        filter: grayscale(100%);
        transform: rotate(-90deg);
      }
      
      .accordion-button:not(.collapsed)::after {
        position: absolute;
        filter: grayscale(100%);
        transform: rotate(0deg) !important;
      }
    }

    .view-course {
      .accordion-button {
        background-color: ${colors.greyscale.light_grey} !important;
      }
    }

    .pick-sync-disciplines {
      .p-picklist-list {
        height: 100%;
      }
    }

    .tooltip {
      z-index: 9999 !important;
    }

    .form-check-input:disabled {
      background: #DDDDDD;
      border-color: #DDDDDD;
    }
  `}
  }
`;

export default GlobalStyle;
